import angular from 'angular';
import {VerOrdenesComponent} from './ver/ver-ordenes.component';
import {OrdenesComponent} from './ordenes.component';
import OrdenesService from './ordenes.service';

/*@ngInject*/
let routesOrdenes = function ($routeProvider) {
    $routeProvider
        .when('/ordenes', {
            template: '<ordenes-list ordenes="$resolve.ordenes.data"></ordenes-list>',
            authenticate: true,
            administrator: true,
            resolve: {
                ordenes: getOrdenesPendientes
            }
        })
        .when('/ordenes/:id', {
            template: '<ordenes-detail orden="$resolve.orden.data"></ordenes-detail>',
            authenticate: true,
            administrator: true,
            resolve: {
                orden: getOrden
            }
        });

    function getOrden(OrdenesService, $route) {
        return OrdenesService.getOrden($route.current.params.id);
    }

    function getOrdenesPendientes(OrdenesService) {
        return OrdenesService.getOrdenesPendientes(20);
    }
};
export default angular.module('pizzuto-autopartes.ordenes', [])
    .config(routesOrdenes)
    .component(OrdenesComponent.selector, OrdenesComponent)
    .component(VerOrdenesComponent.selector, VerOrdenesComponent)
    .service('OrdenesService', OrdenesService)
    .name;



// WEBPACK FOOTER //
// ./client/app/ordenes-route/index.js